import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../data/initialState.common.data';
import {
  fetchServiceLevelType as fetchServiceLevelTypeAPI,
  fetchServiceLocation as fetchServiceLocationAPI,
  fetchContactServiceOfferingAddOn as fetchContactServiceOfferingAddOnAPI,
  fetchShipMethod as fetchShipMethodAPI,
  fetchServicePriceLevel as fetchServicePriceLevelAPI,
  fetchWorkOrderType as fetchWorkOrderTypeAPI,
  fetchServiceResponseType as fetchServiceResponseTypeAPI,
  fetchNoteType as fetchNoteTypeAPI,
  fetchOosCasesReviewStatus as fetchOosCasesReviewStatusAPI,
  fetchCaseType as fetchCaseTypeAPI,
  fetchChargeCode as fetchChargeCodeAPI,
  fetchUserPermissions as fetchUserPermissionsAPI,
  userLoginActivity as userLoginActivityAPI,
  getContractHistoryTypes as getContractHistoryTypesAPI
} from '../../apis/commonAPIs';
import {
  CONTRACTS_DATA,
  NAVIGATE_PATH,
  handlePending,
  handleRejection,
} from '../../constants';
import { ACTIONS_SERICE_LEVEL } from '../../constants/actionCreator';
import { createAsyncThunkWrapper } from '../../services/common/asyncThunkWrapper';

export const fetchServicePriceLevel = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.FETCH_SERVICE_PRICE_LEVEL,
  fetchServicePriceLevelAPI
);

export const fetchWorkOrderType = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.FETCH_WORK_ORDER_TYPE,
  fetchWorkOrderTypeAPI
);

export const fetchServiceLevelType = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.SERVICE_LEVEL_TYPE,
  fetchServiceLevelTypeAPI
);

export const fetchServiceLocation = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.SERVICE_LOCATION,
  fetchServiceLocationAPI
);

export const fetchContactServiceOfferingAddOn = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.SERVICE_OFFERING_ADD_ON,
  fetchContactServiceOfferingAddOnAPI
);

export const fetchShipMethod = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.SERVICE_SHIP_METHOD,
  fetchShipMethodAPI
);

export const fetchServiceResponseType = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.SERVICE_RESPONSE_TYPE,
  fetchServiceResponseTypeAPI
);

export const fetchNoteType = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.NOTE_TYPE,
  fetchNoteTypeAPI
);

export const fetchOosCasesReviewStatus = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.REVIEW_STATUS,
  fetchOosCasesReviewStatusAPI
);

export const fetchCaseType = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.CASE_TYPE,
  fetchCaseTypeAPI
);

export const fetchChargeCode = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.CHARGE_CODE,
  fetchChargeCodeAPI
);

export const fetchUserPermissions = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.USER_PERMISSIONS,
  fetchUserPermissionsAPI
);

export const getContractHistoryTypes = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.getContractHistoryTypes,
  getContractHistoryTypesAPI
);

export const userLoginActivity = createAsyncThunkWrapper(
  ACTIONS_SERICE_LEVEL.USER_LOGIN_ACTIVITY,
  userLoginActivityAPI
);

const commonSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    handleDialog: (state, action) => {
      state.dialog = action?.payload;
    },
    setLoader: (state, action) => {
      state.error = action?.payload;
    },
    handleFormType: (state, action) => {
      state.formType = action?.payload;
    },
    handleFormCancle: (state) => {
      state.formType = { create: false, update: false };
    },
    showLoader: (state) => {
      state.isLoading = true;
    },
    hideLoader: (state) => {
      state.isLoading = false;
    },
    handleToast: (state, action) => {
      state.toast = { ...state.toast, ...action?.payload };
    },
    setSelectedGrid: (state, action) => {
      state.gridRadioSelection = action?.payload;
    },
    handelReset: initialState,
    handleResetGridSelection: (state) => {
      state.gridRadioSelection = null;
    },
    perPageSizeSet: (state, action) => {
      state.perPageSize = action?.payload;
    },

    recordCountSet: (state, action) => {
      state.recordCount = action?.payload;
    },
    //common Alert
    handleAlertBoxOpen: (state, action) => {
      state.alertBoxOpen = action?.payload;
    },
    //handle Collapse
    handleCollpaseClick: (state, action) => {
      state.isExpanded = action?.payload;
    },
    handleSelectedTab: (state, action) => {
      state.selectededTab = action.payload;
    },
    handleInnerSelectedTab: (state, action) => {
      state.innerSelectededTab = action.payload;
    },
    handleInnerOosSelectedTab: (state, action) => {
      state.innerOosSelectededTab = action.payload;
    },
    //handle to set Return URL
    setReturnUrl: (state, action) => {
      state.returnUrl = action?.payload || NAVIGATE_PATH.home;
    },
    handleReRenderModule: (state) => {
      state.reRenderModule = state.reRenderModule + 1;
    },
    handleResetReRenderModule: (state) => {
      state.reRenderModule = initialState.reRenderModule;
    },
    //handle Contracts OOS Level Collapse
    handleCollpaseOOSLevelClick: (state, action) => {
      if (action?.payload) {
        state[
          CONTRACTS_DATA.outOfScopeTab.outOfScopeExpandLevel +
            action?.payload?.levelNum
        ] = action?.payload?.isOpen === null ? true : !action?.payload?.isOpen;
      }
    },
    //handle Out Of Scope Alert Box Open and Close
    handleAlertBoxSave: (state, action) => {
      state.alertBoxSave = action?.payload || false;
    },

    //set Grid page record count
    setPageRecordCount: (state, action) => {
      state.recordCountGrid = action?.payload;
    },

    //set Gird page index
    setPageIndex: (state, action) => {
      state.pageIndexGrid = action?.payload;
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchServiceLevelType.pending, handlePending)
      .addCase(fetchServiceLevelType.fulfilled, (state, action) => {
        state.loading = true;
        state.serviceLevelType = action?.payload;
      })
      .addCase(fetchServiceLevelType.rejected, handleRejection)

      .addCase(fetchServiceLocation.pending, handlePending)
      .addCase(fetchServiceLocation.fulfilled, (state, action) => {
        state.loading = true;
        state.serviceLocation = action?.payload;
      })
      .addCase(fetchServiceLocation.rejected, handleRejection)

      .addCase(fetchContactServiceOfferingAddOn.pending, handlePending)
      .addCase(fetchContactServiceOfferingAddOn.fulfilled, (state, action) => {
        state.loading = true;
        state.serviceOfferingAddOn = action?.payload;
      })
      .addCase(fetchContactServiceOfferingAddOn.rejected, handleRejection)

      .addCase(fetchShipMethod.pending, handlePending)
      .addCase(fetchShipMethod.fulfilled, (state, action) => {
        state.loading = true;
        state.shipMethod = action?.payload;
      })
      .addCase(fetchShipMethod.rejected, handleRejection)

      .addCase(fetchServicePriceLevel.pending, handlePending)
      .addCase(fetchServicePriceLevel.fulfilled, (state, action) => {
        state.loading = true;
        state.serviceLevelPriceType = action?.payload;
      })
      .addCase(fetchServicePriceLevel.rejected, handleRejection)

      .addCase(fetchWorkOrderType.pending, handlePending)
      .addCase(fetchWorkOrderType.fulfilled, (state, action) => {
        state.loading = true;
        state.workOrderType = action?.payload;
      })
      .addCase(fetchWorkOrderType.rejected, handleRejection)

      .addCase(fetchServiceResponseType.pending, handlePending)
      .addCase(fetchServiceResponseType.fulfilled, (state, action) => {
        state.loading = true;
        state.serviceResponseType = action?.payload;
      })
      .addCase(fetchServiceResponseType.rejected, handleRejection)

      .addCase(fetchNoteType.pending, handlePending)
      .addCase(fetchNoteType.fulfilled, (state, action) => {
        state.noteType = action?.payload;
      })
      .addCase(fetchNoteType.rejected, handleRejection)

      .addCase(fetchOosCasesReviewStatus.pending, handlePending)
      .addCase(fetchOosCasesReviewStatus.fulfilled, (state, action) => {
        state.reviewStatus = action?.payload;
      })
      .addCase(fetchOosCasesReviewStatus.rejected, handleRejection)

      .addCase(fetchCaseType.pending, handlePending)
      .addCase(fetchCaseType.fulfilled, (state, action) => {
        state.caseType = action?.payload;
      })
      .addCase(fetchCaseType.rejected, handleRejection)

      .addCase(fetchChargeCode.pending, handlePending)
      .addCase(fetchChargeCode.fulfilled, (state, action) => {
        state.chargeCode = action?.payload;
      })
      .addCase(fetchChargeCode.rejected, handleRejection)

      .addCase(fetchUserPermissions.pending, (state) => {
        state.userPermissionsNotFound = null;
        state.userPermissions = null;
      })
      .addCase(fetchUserPermissions.fulfilled, (state, action) => {
        state.userPermissions = action?.payload;
        state.userPermissionsNotFound = action?.payload ? false : true;
      })
    //   .addCase(fetchUserPermissions.fulfilled, (state, action) => {
    //     //  WILL REMOVE THIS LATER.
    //    //Revert Back Hardcoded Permissions for testing.
    //    const converData =(data)=>{
    //      return data.userAuthorizations?.map((item)=>{
    //          item.isReadOnly = true;
    //          item.canCreate = true;
    //          item.canEdit = true;
    //          item.canDelete = true;
    //        return item;
    //      })
    //    }
    //    const permissions = converData(action?.payload);
    //    state.userPermissions = action?.payload;
    //    state.userPermissions.userAuthorizations = permissions;
    //    state.userPermissionsNotFound = action?.payload ? false : true;
    //  })
      .addCase(fetchUserPermissions.rejected, (state) => {
        state.userPermissionsNotFound = true;
      })

      .addCase(userLoginActivity.pending, (state) => {
        state.userActivityFulfilled = null;
      })
      .addCase(userLoginActivity.fulfilled, (state) => {
        state.userActivityFulfilled = true;
      })
      .addCase(userLoginActivity.rejected, (state) => {
        state.userActivityFulfilled = false;
      })

      .addCase(getContractHistoryTypes.pending, (state) => {
        state.contractHistoryTypes = [];
      })
      .addCase(getContractHistoryTypes.fulfilled, (state, action) => {
        state.contractHistoryTypes = action?.payload;
      })
      .addCase(getContractHistoryTypes.rejected, (state) => {
        state.contractHistoryTypes = [];
      })
      
  },
});

export const {
  handleDialog,
  setLoader,
  handleFormType,
  showLoader,
  hideLoader,
  handleFormCancle,
  handleToast,
  setSelectedGrid,
  handelReset,
  handleResetGridSelection,
  perPageSizeSet,
  recordCountSet,
  handleAlertBoxOpen,
  handleCollpaseClick,
  handleSelectedTab,
  handleInnerSelectedTab,
  handleInnerOosSelectedTab,
  setReturnUrl,
  handleCollpaseOOSLevelClick,
  handleAlertBoxSave,
  handleReRenderModule,
  handleResetReRenderModule,
  setPageRecordCount,
  setPageIndex,
  //tempSetPermissions,
} = commonSlice.actions;

export default commonSlice.reducer;
